import { CreateSurgicalOrderGuideConsultAuthorization } from 'domain/usecases/surgical-order-guides/create-surgical-order-guide-consult-authorization'
import { LoadGuideItem } from 'domain/usecases/surgical-order-guides/load-guide-item'
import {
  LoadSurgicalOrderGuides,
  SurgicalOrderGuide
} from 'domain/usecases/surgical-order-guides/load-surgical-order-guides'
import { LoadSurgicalOrderGuideAuthorization } from 'domain/usecases/surgical-order-guides/load-surgical-order-guides-authorization'
import { makeAutoObservable } from 'mobx'

type Services = {
  loadSurgicalOrderGuides: LoadSurgicalOrderGuides
  loadSurgicalOrderGuideAuthorization: LoadSurgicalOrderGuideAuthorization
  loadGuideItem: LoadGuideItem
  createSurgicalOrderGuideConsultAuthorization: CreateSurgicalOrderGuideConsultAuthorization
}

export class SurgicalOrderGuidesService {
  constructor(private readonly services: Services) {
    makeAutoObservable(this)
  }

  async loadSurgicalOrderGuides(
    surgical_order_id: number
  ): Promise<LoadSurgicalOrderGuides.Model> {
    return this.services.loadSurgicalOrderGuides.load(surgical_order_id)
  }

  async loadSurgicalOrderGuidesGrouped(surgical_order_id: number): Promise<{
    procedures: SurgicalOrderGuide[]
    opme: SurgicalOrderGuide[]
  }> {
    const response = await this.services.loadSurgicalOrderGuides.load(
      surgical_order_id
    )
    const guides = response?.data?.data?.surgicalOrderGuides || []
    return {
      procedures: guides.filter((g) => g.type === 'INTERNACAO'),
      opme: guides.filter((g) => g.type === 'OPME')
    }
  }

  async loadSurgicalOrderGuidesObservations(
    surgical_order_id: number
  ): Promise<{
    procedures: SurgicalOrderGuide[]
    opme: SurgicalOrderGuide[]
  }> {
    const response = await this.services.loadSurgicalOrderGuides.load(
      surgical_order_id,
      true
    )
    const guides = response?.data?.data?.surgicalOrderGuides || []
    return {
      procedures: guides.filter((g) => g.type === 'INTERNACAO'),
      opme: guides.filter((g) => g.type === 'OPME')
    }
  }

  async loadSurgicalOrderGuideAuthorization(
    surgical_order_guide_id: number
  ): Promise<LoadSurgicalOrderGuideAuthorization.Model> {
    return this.services.loadSurgicalOrderGuideAuthorization.load(
      surgical_order_guide_id
    )
  }

  async loadGuideItem(
    health_insurance_procedure_id: number,
    health_insurance_code: number
  ): Promise<LoadGuideItem.Model> {
    return this.services.loadGuideItem.load(
      health_insurance_procedure_id,
      health_insurance_code
    )
  }

  async createSurgicalOrderGuideConsultAuthorization(
    params: CreateSurgicalOrderGuideConsultAuthorization.Params
  ): Promise<CreateSurgicalOrderGuideConsultAuthorization.Model> {
    return this.services.createSurgicalOrderGuideConsultAuthorization.create(
      params
    )
  }
}

export default SurgicalOrderGuidesService
